export default "__VITE_ASSET__C0LfsN5I__"